<div class="card h-100 d-flex flex-column">
  <div class="card-header">
    <app-page-title [breadcrumbItems]="breadCrumbItems" [title]="service.title"/>
  </div>

  <div class="card-body d-flex flex-column flex-grow-1 p-0 overflow-hidden">
    <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between flex-wrap gap-2 px-3 py-2">
      <!-- Search input -->
      <div class="position-relative w-md-100">
        <input
          [formControl]="searchControl"
          autocomplete="off"
          class="form-control search w-md-100"
          placeholder="{{'SEARCH'|translate}}"
          type="text">
        <span class="las la-search search-widget-icon"></span>
        <span class="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"></span>
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs-custom d-flex mx-auto flex-nowrap overflow-auto mb-0">
        <li *ngFor="let tab of tabs" class="nav-item">
          <a
            (click)="setActiveTab(tab.key)"
            [ngClass]="{ 'active': activeTab() === tab.key }"
            class="nav-link cursor-pointer text-nowrap"
          >
            <i [class]="tab.icon"></i>
            <span class="fs-17">{{ tab.label | translate }}</span>
          </a>
        </li>
      </ul>

      <!-- Add button -->
      <button
        *ngIf="service.hasAdd"
        (click)="onAdd()"
        class="btn btn-sm bg-primary text-light">
        {{ 'APARTMENT.ADDPROPERTY'|translate }}
      </button>
    </div>

    <!-- CONTENT -->
    <div class="tab-content flex-grow-1 overflow-hidden">
      @if (activeTab() === 'card' || activeTab() === 'table') {
        <app-properties-table class="h-100" [type]="activeTab()" #table></app-properties-table>
      }
      @if (activeTab() == 'others') {
        <!-- Other content -->
      }
    </div>
  </div>

</div>
